import script from "./PropertiesGridView.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertiesGridView.vue?vue&type=script&setup=true&lang=js"

import "./PropertiesGridView.vue?vue&type=style&index=0&id=ce8e4ce0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce8e4ce0"]])

export default __exports__